import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { DataService } from './../data.service';
import { HelperService } from './../helper.service';
import { Subscription, interval } from 'rxjs';

@Component({
    selector: 'app-timing',
    templateUrl: './timing.component.html',
    styleUrls: ['./timing.component.css']
})
export class TimingComponent implements OnInit {

    constructor(
        public dataService: DataService,
        public helperService: HelperService,
        public fb: FormBuilder
    ) { }

    private subscription: Subscription;
    public countdown: string = "";
    public bibLoadedRacer: any = {}; // temporary racerDoc
    public now: any = new Date();

    public lapBibSubmission: any = this.fb.group({
        bib: null
    });

    ngOnInit(): void {
        let scope = this;
        if (this.dataService.racers.length == 0){
            this.dataService.getAllRacers();
        }
        if (Date.parse(this.now.toISOString()) > Date.parse(this.dataService.raceProfiles.backyard2023.startTime)){
            this.dataService.raceStarted = true;
        }
        this.subscription = interval(500) // testing 500, 1000 is the original 1 second loop
            .subscribe(x => {
                if (!scope.dataService.raceStarted) {
                    scope.countdownGenerate(scope.dataService.raceProfiles.backyard2023.startTime);
                    scope.runnersCheckedIn();
                } else {
                    // race has started - loads more to calculate
                    scope.dataService.onGoingRace("backyard2023");
                    scope.updateTime();
                }
                // check if we need to kick off an event
                if (Math.floor(Date.parse(new Date().toISOString()) / 1000) == Math.floor(Date.parse(scope.dataService.raceProfiles.backyard2023.startTime) / 1000)) {
                    scope.dataService.startRace("backyard2023");
                    // console.log('starting this race.');
                }
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private updateTime(){
        this.now = new Date();
    }

    public countdownGenerate(date){
        this.countdown = this.helperService.friendlyTimeDuration( Date.parse(date) - Date.parse(new Date().toISOString()), "ms");
    }

    public setBibToForm(bibNo){
        // console.log(bibNo);
        this.lapBibSubmission.patchValue({
            bib: bibNo
        });
        this.bibLookup("backyard2023");
    }

    private runnersCheckedIn() {
        //for (let e in this.dataService.raceProfiles){
            this.dataService.raceProfiles["backyard2023"].racersCheckedInCount = 0; // unset -then build up.
            this.dataService.raceProfiles["backyard2023"].totalRacersInEvent = 0;
            for (let r = 0; r < this.dataService.racers.length; r++){
                
                if (this.dataService.racers[r].checkedIn && this.dataService.racers[r]["backyard2023"].registered){
                    this.dataService.raceProfiles["backyard2023"].racersCheckedInCount++;
                }
                if (this.dataService.racers[r]["backyard2023"]) {
                    if (this.dataService.racers[r]["backyard2023"].registered) {
                        this.dataService.raceProfiles["backyard2023"].totalRacersInEvent++;
                    }
                }
            }
        //}
    }

    public lapCompleted(raceId) {
        // console.log('submitted - validate - runner is eligible to complete this lap');
        // console.log(this.lapBibSubmission);
        // ok, need to lookup the racer by bib # & find the current lap in this races' laps, then mark that lap completed.

        let lap = {
            lapTime: (60 * 60 * 1000) - this.dataService.lapTimeRemainingMS(),
            division: this.helperService.racerDivision(this.bibLoadedRacer),
            firstName: this.bibLoadedRacer.firstName,
            lastName: this.bibLoadedRacer.lastName,
            raceId: raceId,
            bibNumber: this.lapBibSubmission.value.bib,
            lapNumber: this.dataService.raceProfiles[raceId].lapCount + 1
        };

        this.dataService.completedLaps.unshift(lap);
        if (this.dataService.completedLaps.length > 5){
            this.dataService.completedLaps.pop();
        }
        // need to update the racerDoc at the dataService level && save back to database as well.
        this.dataService.completeLap(this.bibLoadedRacer, lap);

        // unset the temp bibLoadedRacer doc;
        this.bibLoadedRacer = {};
        this.lapBibSubmission.patchValue({
            bib: null
        });
    }

    public bibLookup(raceId){
        if (this.lapBibSubmission.value.bib){
            // console.log('looking for bib: '+this.lapBibSubmission.value.bib);
            if (this.lapBibSubmission.value.bib > 100 && this.lapBibSubmission.value.bib < 200){
                // console.log("range matched...");
                let noMatch = true;
                // check if th ebib number is within the racersOnCourse array
                for (let b = 0; b < this.dataService.raceProfiles.backyard2023.racersOnCourse.length; b++){
                    if (this.dataService.raceProfiles.backyard2023.racersOnCourse[b] == this.lapBibSubmission.value.bib){
                        for (let r = 0; r < this.dataService.racers.length; r++){
                            // console.log(this.dataService.racers[r][raceId].bibNumber+" v "+this.lapBibSubmission.value.bib);
                            if (this.dataService.racers[r][raceId]) {
                                if (this.dataService.racers[r][raceId].bibNumber == this.lapBibSubmission.value.bib) {
                                    // console.log("matched racer");
                                    this.bibLoadedRacer = this.dataService.racers[r];
                                    noMatch = false;
                                }
                            }
                        }
                    }
                }

                if (noMatch){
                    this.bibLoadedRacer = {};
                    this.bibLoadedRacer.firstName = "Not Found On The Course";
                }
            } else {
                this.bibLoadedRacer = {};
            }
        } else {
            this.bibLoadedRacer = {};
        }


    }

    public toggleCheckedIn(racer){
        racer.checkedIn = !racer.checkedIn;
        this.dataService.updateRacer(racer.email, {checkedIn: racer.checkedIn}).subscribe(res => {
            // console.log(res);
            console.log("racer checked in/out");
        })
    }
}
